import React from "react";

const Spinner = () => (
    <div className="spinner">
        <i className="icon-spinner icon-3x" />
    </div>
);

export function getComponentByName(externalComponentModuleName: string) {
    let LazyComponent: any;
    switch (externalComponentModuleName) {
        case "oc_ui/SideCaddy":
            LazyComponent = React.lazy(() => import("oc_ui/SideCaddy"));
            break;
        case "oc_ui/SavedCartsList":
            LazyComponent = React.lazy(() => import("oc_ui/SavedCartsList"));
            break;

        case "cia_ui/Banner":
            LazyComponent = React.lazy(() => import("cia_ui/Banner"));
            break;
        case "cia_ui/StoreListItem":
            LazyComponent = React.lazy(() => import("cia_ui/StoreListItem"));
            break;
        case "cia_ui/StoreListTilesRow":
            LazyComponent = React.lazy(() => import("cia_ui/StoreListTilesRow"));
            break;
        case "cia_ui/Recommendations":
            LazyComponent = React.lazy(() => import("cia_ui/Recommendations"));
            break;
        case "cia_ui/IdamCompatibleLogoutLink":
            LazyComponent = React.lazy(() => import("cia_ui/IdamCompatibleLogoutLink"));
            break;

        case "sd_articlesearch_ui/GlobalHeader":
            LazyComponent = React.lazy(() => import("sd_articlesearch_ui/GlobalHeader"));
            break;
        case "sd_articlesearch_ui/MetroLogo":
            LazyComponent = React.lazy(() => import("sd_articlesearch_ui/MetroLogo"));
            break;
        case "sd_articlesearch_ui/SearchResultArticle":
            LazyComponent = React.lazy(() => import("sd_articlesearch_ui/SearchResultArticle"));
            break;
        case "sd_articlesearch_ui/SearchResultNoArticle":
            LazyComponent = React.lazy(() => import("sd_articlesearch_ui/SearchResultNoArticle"));
            break;

        case "sd_pdp_ui/BulkDiscountTiersDisplay":
            LazyComponent = React.lazy(() => import("sd_pdp_ui/BulkDiscountTiersDisplay"));
            break;

        default:
            LazyComponent = <>Component ${externalComponentModuleName} does not exist in cia explore ui</>;
    }

    const componentWrapper = (props: any) => (
        <React.Suspense fallback={<Spinner />}>
            <LazyComponent {...props} />
        </React.Suspense>
    );

    const slashIndex = externalComponentModuleName.lastIndexOf("/");
    if (slashIndex === -1) {
        componentWrapper.displayName = externalComponentModuleName;
    } else {
        componentWrapper.displayName = externalComponentModuleName.substring(slashIndex + 1);
    }

    return componentWrapper;
}
